import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  UserContext,
  UserContextType,
} from "../contexts/UserContext/UserContext";
import { getToken } from "../utils/authHelpers";

const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const context = useContext(UserContext) as UserContextType;
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await getToken();
        if (token) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  // Show a loading state while checking authentication status
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  // Redirect to the sign-in page if the user is not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} />;
  }

  // If authenticated, render the child components
  return children;
};

export default RequireAuth;
